import styles from './styles.module.css';
import { Typography } from '@mui/material';
import classnames from 'classnames';
import { ArrowDownInCircle } from './ArrowDownInCircle';
import { FC } from 'react';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import * as React from 'react';
interface BannerItemProps {
  titleEn?: string;
  subtitleEn?: string;
  btnTextEn?: string;
  link?: string;
  src?: string;
  onDeleteIcon: () => void;
  onEditIcon: () => void;
}

export const BannerItem: FC<BannerItemProps> = ({
   titleEn,
   subtitleEn,
   btnTextEn,
   link,
   src,
   onDeleteIcon,
   onEditIcon
}) => {
  return (
    <div className={styles.root}>
      <div className={styles.header}>
        <div className={styles.actions}>
          <EditIcon onClick={onEditIcon} />
          <DeleteIcon color="error" onClick={onDeleteIcon} />
        </div>
      </div>
      <section className={styles.embla}>
        <div className={styles.viewport}>
          <div className={styles.container}>
            <div
              className={classnames(styles.slide, styles.fullWidth, styles.slideBg)}
              style={{ backgroundImage: `url(${process.env.REACT_APP_API_URL_STATIC}/${src})` }}
            >
              <div className={classnames(styles.info, styles.fullWidth)}>
                <div className={styles.text}>
                  <Typography className={styles.title}>
                    {titleEn}
                  </Typography>
                  {
                    subtitleEn &&  <Typography className={styles.subtitle}>
                      {subtitleEn}
                    </Typography>
                  }
                  {
                    link && btnTextEn &&  <Typography
                      className={classnames(styles.buttonText, styles.link, styles.cta)}
                    >
                      {btnTextEn}
                      <ArrowDownInCircle color="green" />
                    </Typography>
                  }
                </div>
              </div>

              <img className={styles.srOnly} src={src} alt="slide image" />
            </div>
          </div>
        </div>
      </section>
    </div>
  )
}